import { Cap } from './Cap';
import { Root, type RootProps } from './Root';
import { Select } from './Select';
import { Threshold } from './Threshold';
import { Type } from './Type';

export type { RootProps as AggregatedMeasurementRootProps };

export const AggregatedMeasurement = {
  Root,
  Select,
  Type,
  Threshold,
  Cap,
};
